<div class="no-data">
    <div class="image-div">
        <img src="../../../../assets/images/icons/no-data.svg" alt="">
    </div>
    <div class="text-div">
        <p>No data found</p>
    </div>
</div>
